"use strict";
exports.__esModule = true;
var axios_1 = require("axios");
var CryptoJS = require("crypto-js");
var Symbol = require('es6-symbol');
var errors_1 = require("./errors");
var errors_2 = require("./errors");
var createHMACget = Symbol('createHMACget');
var createHMACother = Symbol('createHMACother');
var TOKEN_COOKIE_KEY = "smartorg_api_jwt";
var TOKEN_COOKIE_KEY_TIME = "smartorg_api_jwt_time";
function setCookie(cname, cvalue, exmins) {
    var d = new Date();
    d.setTime(d.getTime() + (exmins * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function eraseCookie(name) {
    setCookie(TOKEN_COOKIE_KEY, "", -1);
}
function saveToken(token) {
    setCookie(TOKEN_COOKIE_KEY, token, 35);
    setCookie(TOKEN_COOKIE_KEY_TIME, new Date().getTime(), 35);
}
function getToken() {
    return getCookie(TOKEN_COOKIE_KEY);
}
var Protocols = /** @class */ (function () {
    function Protocols(endpoint, path_, callbackContainer) {
        this.MAX_RETRY = 10000;
        this.RETRY_DELAY = 15000; // milliseconds
        this.endpoint_ = endpoint;
        this.networkErrorHandler = function (error) {
            if (error === void 0) { error = undefined; }
            if (callbackContainer.networkErrorHandler) {
                callbackContainer.networkErrorHandler(error);
            }
            else if (error) {
                return Promise.reject(new errors_1.APIError({
                    'status': -1,
                    'message': error.message
                }));
            }
        };
        if (typeof (endpoint) === 'undefined' || !endpoint) {
            var endPointErrMsg = "Please pass in a valid endpoint - eg https://localhost:443 ";
            console.error(endPointErrMsg);
            console.warn("abbending program and exiting");
            return;
        }
        else {
            console.info("endpoint supplied as " + endpoint);
        }
        this.defaultpath = '';
        if (typeof (path_) === 'undefined' || !path_) {
            console.log("path not provided -- defaulting to " + this.defaultpath);
            this.path1 = this.defaultpath;
        }
        else {
            this.path1 = path_;
            console.log("User defined path passed in is: " + path_);
        }
    }
    Protocols.prototype.hasToken = function () {
        return getToken() || false;
    };
    Protocols.prototype.logout = function () {
        eraseCookie(TOKEN_COOKIE_KEY);
    };
    Protocols.prototype.redirectToLogin = function () {
        this.logout();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        if (!window.location.hash.startsWith('#!/login')) {
            window.location.href = '#/login';
        }
    };
    Protocols.prototype.makeCredentials = function (credentials) {
        this.credentials = {
            username: credentials.username,
            secret: CryptoJS.MD5(credentials.password).toString()
        };
    };
    Protocols.prototype.createHmac = function (path, body) {
        if (!this.credentials || !this.credentials.secret || !this.credentials.username) {
            var errMsg = "Please authenticate() before calling other API values";
            console.warn(this.credentials);
            console.error(errMsg);
            throw new errors_2.AuthenticationError({ message: errMsg });
        }
        else {
            var hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, this.credentials.secret);
            hmac.update(decodeURIComponent(path));
            if (typeof body !== 'undefined') {
                hmac.update(JSON.stringify(body));
            }
            // let sig_ = `applicationname ${this.credentials.username}:${hmac.finalize()}`;
            // console.log(`creating hmac for ${this.credentials.username} on path ${path}`);
            // console.log(sig_);
            return "applicationname " + this.credentials.username + ":" + hmac.finalize();
        }
    };
    Protocols.prototype.createAuthString = function () {
        var token = getToken();
        if (token) {
            return "jwttoken " + token;
        }
        else {
            this.redirectToLogin();
            return "";
        }
    };
    Protocols.prototype._getPath = function (action) {
        if (!this.path1) {
            return "/" + action;
        }
        else {
            return "/" + this.path1 + "/" + action;
        }
    };
    /**
     * Use promise to wrap a return value for setTimeout.
     * This function handles retry when network issue happens.
     *
     * @param inputFunc
     * @param retry
     * @return {*}
     */
    Protocols.prototype.retry = function (path, authRequired, inputFunc, retry) {
        if (retry === void 0) { retry = 1; }
        if (retry <= this.MAX_RETRY) {
            var that_1 = this;
            this.networkErrorHandler(new errors_1.APIError({
                'status': -1,
                'message': "Network connection broken.",
                'timeout': this.RETRY_DELAY / 1000 // Retry time.
            }));
            return new Promise(function (resolve) {
                setTimeout(function () {
                    resolve(that_1.apiPromise(path, authRequired, inputFunc, retry));
                }, that_1.RETRY_DELAY);
            });
        }
        else {
            var err = new errors_1.APIError({
                'status': -1,
                'message': "Network Error. Maximum retry reached."
            });
            this.networkErrorHandler(err);
            return Promise.reject(err);
        }
    };
    /**
     * Handle api call promise resolve and reject.
     *
     * @param path {string} Api path.
     * @param authRequired {boolean} Is authentication required for this call.
     * @param inputFunc {Function} Promise object.
     * @param retry
     * @param redirect {boolean} Whether redirect to login or not.
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiPromise = function (path, authRequired, inputFunc, retry, redirect) {
        var _this = this;
        if (retry === void 0) { retry = 0; }
        if (redirect === void 0) { redirect = true; }
        var url = "" + this.endpoint_ + path;
        var authHeader = authRequired ? this.createAuthString() : null;
        if (authRequired && !authHeader) {
            return Promise.reject('No authentication info or authentication expired.');
        }
        var promise = inputFunc(url, authHeader);
        var that = this;
        return promise.then(function (response) {
            _this.networkErrorHandler();
            if (response.data.token) {
                saveToken(response.data.token);
                return response.data.data;
            }
            else {
                return response.data;
            }
        })["catch"](function (error) {
            if (error.status > 0 || error.response) {
                if (error.response.status === 403) {
                    var statusText = error.response.data.message;
                    var errorMessage = void 0;
                    if (statusText === "TOKEN_EXPIRED") {
                        errorMessage = "Section time out, redirecting to login page...";
                    }
                    else if (statusText === "TOKEN_EXPIRED") {
                        errorMessage = "Invalid section, redirecting to login page...";
                    }
                    else if (statusText === "AUTHENTICATION_FAILED") {
                        errorMessage = "Failed to authenticate, redirecting to login page...";
                    }
                    else {
                        errorMessage = "System Error: " + statusText;
                    }
                    var that_2 = _this;
                    if (redirect) {
                        setTimeout(function () {
                            that_2.redirectToLogin();
                        }, 3000);
                    }
                    eraseCookie(TOKEN_COOKIE_KEY);
                    return Promise.reject(new errors_1.APIError({
                        'status': error.response.status,
                        'statusText': error.response.statusText,
                        'message': errorMessage
                    }));
                }
                else {
                    return Promise.reject(new errors_1.APIError({
                        'status': error.response.status,
                        'statusText': error.response.statusText,
                        'message': error.response.data.message
                    }));
                }
            }
            else {
                // FIXME: This will be called if user encounter a 404.
                return that.retry(path, authRequired, inputFunc, ++retry);
            }
        });
    };
    /**
     * Handle api get request.
     *
     * @param path {string} Path of api call without endpoint.
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiGet = function (path) {
        return this.apiPromise(path, true, function (url, authHeader) {
            return axios_1["default"].get(url, {
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    Authorization: authHeader
                }
            });
        });
    };
    /**
     * Handle api get request bypassing authentication
     *
     * @param path {string} Path of api call without endpoint.
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiGetNoAuth = function (path) {
        return this.apiPromise(path, false, function (url, authHeader) {
            return axios_1["default"].get(url);
        });
    };
    /**
     * Handle api delete request.
     *
     * @param path {string} Path of api call without endpoint.
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiDelete = function (path) {
        return this.apiPromise(path, true, function (url, authHeader) {
            return axios_1["default"]["delete"](url, {
                headers: { Authorization: authHeader }
            });
        });
    };
    /**
     * Handle api post request.
     *
     * @param path {string} Path of api call without endpoint.
     * @param body {object} Body object contains other non-string info..
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiPost = function (path, body) {
        return this.apiPromise(path, true, function (url, authHeader) {
            return axios_1["default"].post(url, body, {
                headers: {
                    Authorization: authHeader
                }
            });
        });
    };
    Protocols.prototype.apiAuth = function (path, body) {
        var _this = this;
        this.logout();
        var inputFunc = function (url, authHeader) {
            return axios_1["default"].post(url, body, {
                headers: { Authorization: _this.createHmac(path, body) }
            });
        };
        return this.apiPromise(path, false, inputFunc, 0, false);
    };
    /**
     * Handle api post request bypassing authentication.
     *
     * @param path {string} Path of api call without endpoint.
     * @param body {object} Body object contains other non-string info..
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiPostNoAuth = function (path, body) {
        return this.apiPromise(path, false, function (url, authHeader) {
            return axios_1["default"].post(url, body);
        });
    };
    /**
     * Handle api put request.
     *
     * @param path {string} Path of api call without endpoint.
     * @param body {object} Body object contains other non-string info..
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiPut = function (path, body) {
        return this.apiPromise(path, true, function (url, authHeader) {
            return axios_1["default"].put(url, body, {
                headers: {
                    Authorization: authHeader
                }
            });
        });
    };
    /**
     * Handle api put request bypassing authentication.
     *
     * @param path {string} Path of api call without endpoint.
     * @param body {object} Body object contains other non-string info..
     * @returns {*|Promise|axios.Promise}
     */
    Protocols.prototype.apiPutNoAuth = function (path, body) {
        return this.apiPromise(path, false, function (url, authHeader) {
            return axios_1["default"].put(url, body);
        });
    };
    return Protocols;
}());
exports["default"] = Protocols;
//# sourceMappingURL=protocols.js.map


// WEBPACK FOOTER //
// ./app/lib/smartorg-api/protocols.js